// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2Ei8p{display:-ms-flexbox;display:flex}._2Vqo4{padding-left:16px}._2zRvC{line-height:36px}._2VzAw{color:#95a1bd;line-height:21px;margin-top:16px}._8R-w{height:36px}._8R-w path{vector-effect:none!important}", ""]);
// Exports
exports.locals = {
	"wrapper": "_2Ei8p",
	"message": "_2Vqo4",
	"messageHeader": "_2zRvC",
	"messageDetails": "_2VzAw",
	"headerIcon": "_8R-w"
};
module.exports = exports;
